import React, { ReactNode } from 'react';
import { useGoftino } from '../hooks/useGoftino';

interface GoftinoWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that initializes Goftino integration
 * Should be placed inside AuthProvider and BranchProvider
 */
const GoftinoWrapper: React.FC<GoftinoWrapperProps> = ({ children }) => {
  // Initialize Goftino integration
  useGoftino();

  return <>{children}</>;
};

export default GoftinoWrapper;
